export const darkTheme = {
  color: "hsl(0, 0%, 100%)",
  primary: {
    bgcolor: "hsl(207, 26%, 17%)",
  },
  secondary: {
    bgcolor: "hsl(209, 23%, 22%)",
  },
};
export const lightTheme = {
  color: "hsl(200, 15%, 8%)",
  primary: {
    bgcolor: "hsl(0, 0%, 98%)",
  },
  secondary: {
    bgcolor: "hsl(0, 0%, 100%)",
  },
};
